import axios from '../axios';

const mosadsAPI = {
  getAllMosads: async () => {
    const response = await axios.get('/mosads');
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`/mosads/${id}`);
    return response.data;
  },

  create: async (mosadData) => {
    const response = await axios.post('/mosads', mosadData);
    return response.data;
  },

  update: async (id, mosadData) => {
    const response = await axios.put(`/mosads/${id}`, mosadData);
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`/mosads/${id}`);
    return response.data;
  },

  getCustomers: async (id) => {
    const response = await axios.get(`/mosads/${id}/customers`);
    return response.data;
  },

  getTransactions: async (id) => {
    const response = await axios.get(`/mosads/${id}/transactions`);
    return response.data;
  },

  getEmployees: async () => {
    const response = await axios.get('/mosads/employees');
    return response.data;
  },

  addEmployees: async (mails) => {
    const normalizedMails = Array.isArray(mails) ? mails : [];
    const response = await axios.post('/mosads/employees', {
      mails: normalizedMails,
      employees: normalizedMails,
    });
    return response.data;
  },

  updateEmployee: async (usr_id, payload) => {
    const response = await axios.patch(`/mosads/employees/${usr_id}`, payload);
    return response.data;
  },
};

export default mosadsAPI; 